/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/ellipsis-vertical
 */
import { default as DefaultIcon } from '~icons/lucide/ellipsis-vertical';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const EllipsisVerticalIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
